import React, { Component } from 'react';
import { Notifier } from '@airbrake/browser';
import { AIRBRAKE_API_KEY, AIRBRAKE_PROJECT_ID, BUILD_ENV, BLACKLISTED_ERRORS } from '../../../../constants';
export default class MyErrorBoundary extends Component {
  state = {
    error: null
  }

  airbrake = new Notifier({
    projectId: AIRBRAKE_PROJECT_ID,
    projectKey: AIRBRAKE_API_KEY
  });

  componentDidMount() {
  }

  componentWillUnmount() {
  }
  static getDerivedStateFromError(error) {
  // Update state so next render shows fallback UI.
  return { error: error };
}

componentDidCatch(error, info) {
  // Log the error to an error reporting service
  if (!BLACKLISTED_ERRORS.includes(error.message)) {
    this.airbrake.notify({
      error: error,
      environment: { env: BUILD_ENV },
      params: {info: info}
    });
  }
}

  render() {
    if (this.state.error) {
      
      return (
        <div style={{ height: '100vh', width: '100%', textAlign: 'center', paddingTop: '8rem', paddingLeft: '2rem', paddingRight: '2rem' }}>
          <i className="far fa-4x fa-map-marker-slash has-text-dark"></i>
          <p className="mt-2" style={{ fontSize : '1.5rem' }}>Sorry, we are having trouble loading the map.</p>

        </div>)
    }
    return this.props.children;
  }
}